"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Modal_1 = require("./Modal/Modal");
const Button_1 = require("./Button");
const YesNoModal = ({ btnColor, btnSize, btnText, title, content, contentIsHtml, answerCb, }) => {
    const [modalOpen, setModalOpen] = (0, react_1.useState)(false);
    const handleClick = (event) => {
        setModalOpen(false);
        if (event.target.value) {
            answerCb();
        }
    };
    const renderContent = () => {
        if (contentIsHtml && typeof content === 'object') {
            return (0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: content });
        }
        else if (typeof content === 'string') {
            return (0, jsx_runtime_1.jsx)("div", { children: content });
        }
        return null;
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "py-1 justify-content-between d-flex flex-wrap gap-1", children: [(0, jsx_runtime_1.jsx)(Button_1.Button, { type: "button", className: "theme-button-secondary", color: btnColor || 'primary', size: btnSize || 'sm', onClick: () => {
                    setModalOpen(true);
                }, children: btnText }), (0, jsx_runtime_1.jsx)(Modal_1.Modal, { isOpen: modalOpen, centered: true, toggle: () => setModalOpen(!modalOpen), title: title, footer: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Button_1.Button, { color: "light", onClick: handleClick, children: __.trans('app.general_no') }), (0, jsx_runtime_1.jsx)(Button_1.Button, { className: "theme-button-primary", size: "lg", onClick: handleClick, value: 1, children: __.trans('app.general_yes') })] }), children: renderContent() })] }));
};
exports.default = YesNoModal;
